import type { ProductPrice, ProductPricesCollection } from 'palette/candidates/ProductPrices/types';
import type { CartItemPrices, CartItemPriceV2 } from '@common/Checkout/shared/components/CartItem/types';
import { camelToSnakeCase } from '@helpers/camelToSnakeCase';

export function formatProductPriceToSnakeCase(prices: CartItemPrices): ProductPricesCollection[] {
    return prices.map(priceArray => priceArray.map((priceObject) => {
        const updatedPriceObject: { [key: string]: any } = {};

        for (const key in priceObject) {
            if (Object.prototype.hasOwnProperty.call(priceObject, key)) {
                const newKey = camelToSnakeCase(key);
                updatedPriceObject[newKey as keyof ProductPrice] = priceObject[key as keyof CartItemPriceV2];
            }
        }

        return updatedPriceObject as ProductPrice;
    }));
}
